import requestWrapper from "@/services/api/utils/requestWrapper";
import { IGenericResponse } from "@/services/interfaces";

export default async (): Promise<IGenericResponse> => {
  const request = {
    url: "/api/account/orders",
    method: "GET",
  };

  return await requestWrapper(request);
};
